import { useEffect, useState, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import * as S from './styles';
import * as CXT from 'context/globalContext';
import 'firebase/analytics';
import firebase from 'firebase/compat/app';

import { Header } from 'components/Header';
import { findData } from 'services/findCEP';
import { PopUpDanger } from '../Register/components/PopUpDanger';
import { PopUpWarning } from '../Register/PopUpWarning';
import { TitleWrapperRegister } from './components/TitleWrapperRegister';
import { returnOpcaoSimulacaoFinanciamento } from './utils/returnObject/returnOpcaoSimulacaoFinanciamento';
import PessoaFisicaForm from 'pages/RegisterUpdate/pessoa-fisica';
import { padStart, size } from 'lodash';
import { unMask } from 'utils/mask';
import { ShowPopUp } from './components/ShowPopup';
import PessoaJuridicaForm from 'pages/RegisterUpdate/pessoa-juridica';
import { validateEstoqueAndCustomer } from 'utils/propostaUtils';
import { postPedido } from '../../utils/propostaUtils';

Bugsnag.start({
  apiKey: '00621c4c68a1b2bd34e7458c0f8d29bc',
  plugins: [new BugsnagPluginReact()],
});

export default function ClientRegisterUpdate() {
  const history = useHistory();
  const analytics = firebase.analytics();
  const globalContext = useContext(CXT.Context);

  const [identifier, setIdentifier] = useState<string>('');
  const [identifierType, setIdentifierType] = useState<
    'CPF' | 'CNPJ' | undefined
  >(undefined);

  const [municipios, setMunicipios] = useState<any[]>([]);
  const [popUpDangerActive, setPopUpDangerActive] = useState<boolean>(false);

  const [person] = useState(JSON.parse(localStorage.getItem('client') || '{}'));
  const [car, setCar] = useState<any>(undefined);

  const carData = JSON.parse(localStorage.getItem('car') || '{}');
  const parcel = JSON.parse(localStorage.getItem('parcel') || '{}');
  const vehiclePlate = JSON.parse(localStorage.getItem('vehiclePlate') || '{}');

  const pessoaFisicaFormRef = useRef<{ submitForm: () => void }>(null);
  const pessoaJuridicaFormRef = useRef<{ submitForm: () => void }>(null);
  const [acao, setAcao] = useState<'credito' | null>(null);

  useEffect(() => {
    getOptions();

    if (carData.marcas === undefined || parcel.prazo === undefined) {
      history.push('/client');
    } else {
      if (carData.marcas?.length > 0) {
        setCar(carData.marcas[0].linhas[0].versoes[0].modelos[0].veiculos[0]);
      }
    }

    if (person?.cpf) {
      triggerLoadData(`${person.cpf}`);
    } else if (person?.cnpj) {
      triggerLoadData(`${person.cnpj}`);
    }
  }, []);

  const triggerLoadData = (cpfCnpj?: string) => {
    if (!cpfCnpj) {
      cpfCnpj = identifier;
    }

    if (cpfCnpj) {
      let length = size(unMask(cpfCnpj, '\\.|-'));
      if (length < 11) {
        cpfCnpj = padStart(cpfCnpj, 11, '0');
        length = size(cpfCnpj);
      }

      let type: 'CPF' | 'CNPJ' | undefined;
      if (length === 11) type = 'CPF';
      else if (length >= 12 && length <= 14) type = 'CNPJ';

      setIdentifier(cpfCnpj);
      setIdentifierType(type);
    }
  };

  const onMissingCustomerInformation = () => {
    history.push('/client');
  };

  const handleCheckId = (response: any) => {
    const dataResponse = response.data.data;

    if (dataResponse.status === 'OK') {
      globalContext.setIsLoading(false);
      toast.success('Pedido cadastrado com sucesso!');
      history.push('/sucess');
    }

    if (dataResponse.status === 'NOK') {
      globalContext.setCodPropostaExistente(dataResponse.codPropostaExistente);

      switch (dataResponse.tipoValidacao) {
        case 'PROPOSTA_PARA_ATUALIZAR':
          globalContext.setPopUpActive([true, false, false, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_EM_ANALISE':
          globalContext.setPopUpActive([false, true, false, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_EM_ANDAMENTO':
          globalContext.setPopUpActive([false, false, true, false]);
          globalContext.setIsLoading(false);
          break;
        case 'PROPOSTA_RECUSADA':
          globalContext.setPopUpActive([false, false, false, true]);
          globalContext.setIsLoading(false);
          break;
        case 'LIMITE_PROPOSTAS_EM_ANDAMENTO':
          globalContext.setWarningData({
            title: 'AÇÃO INDISPONÍVEL',
            label: dataResponse.mensagemRetornoHtml ?? '',
            isVehicleName: false,
            isActive: true,
            outOfOrderVehicle: false,
            returnMessageVehicle: '',
          });
          globalContext.setIsLoading(false);
          break;
        default:
          globalContext.setIsLoading(false);
          toast.error(dataResponse.mensagem);
      }
    }
  };

  const handlePedido = (personSubmitResponse: any) => {
    validateEstoqueAndCustomer(vehiclePlate?.id, person.id, globalContext)
      .then(() => {
        history.push('/avalista');
      })
      .catch((err) => {
        Bugsnag.notify(err);
        toast.error('Erro ao validar cliente');
      })
      .finally(() => {
        globalContext.setIsLoading(false);
        setAcao(null);
      });
  };

  async function getOptions() {
    findData
      .GetMunicipio()
      .then((response) => {
        setMunicipios(response.data.data);
      })
      .catch((err) => {
        Bugsnag.notify(err);
        toast.error('Erro ao carregar os municípios');
      });
  }

  const finishCallbackPessoaFisica = async (responseCliente: any) => {
    const clienteAtualizado = responseCliente ?? person;

    if (acao === 'credito') {
      try {
        globalContext.setIsLoading(true);

        await validateEstoqueAndCustomer(
          vehiclePlate?.id,
          clienteAtualizado?.id ?? person?.id,
          globalContext
        );

        await postPedido(
          car,
          parcel,
          clienteAtualizado,
          globalContext,
          handleCheckId
        );
      } catch (error) {
        Bugsnag.notify(error as Error);
        toast.error('Erro ao cadastrar pedido');
      } finally {
        globalContext.setIsLoading(false);
        setAcao(null);
      }
    } else {
      validateEstoqueAndCustomer(
        vehiclePlate?.id,
        clienteAtualizado?.id ?? person?.id,
        globalContext
      )
        .then(() => {
          history.push('/avalista');
        })
        .finally(() => {
          globalContext.setIsLoading(false);
        });
    }
  };

  const finishCallbackPessoaJuridica = async (responseCliente: any) => {
    const clienteAtualizado = responseCliente ?? person;

    if (acao === 'credito') {
      try {
        globalContext.setIsLoading(true);

        await validateEstoqueAndCustomer(
          vehiclePlate?.id,
          clienteAtualizado?.id ?? person?.id,
          globalContext
        );

        await postPedido(
          car,
          parcel,
          clienteAtualizado,
          globalContext,
          handleCheckId
        );
      } catch (error) {
        Bugsnag.notify(error as Error);
        toast.error('Erro ao cadastrar pedido');
      } finally {
        globalContext.setIsLoading(false);
        setAcao(null);
      }
    } else {
      validateEstoqueAndCustomer(
        vehiclePlate?.id,
        clienteAtualizado?.id ?? person?.id,
        globalContext
      )
        .then(() => {
          history.push('/avalista');
        })
        .finally(() => {
          globalContext.setIsLoading(false);
        });
    }
  };

  return (
    <>
      <Header onRefreshClick={getOptions} />
      <S.Wrapper>
        <TitleWrapperRegister />
        {identifierType === 'CPF' && (
          <PessoaFisicaForm
            key={`client-${identifier}`}
            role="client"
            ref={pessoaFisicaFormRef}
            customerCpf={identifier}
            municipios={municipios}
            stopLoadingOnFinish={false}
            finishCallback={finishCallbackPessoaFisica}
            missingCustomerDataCallback={onMissingCustomerInformation}
            extraActions={
              <S.ButtonSkip
                onClick={() => {
                  setAcao('credito');
                  pessoaFisicaFormRef.current?.submitForm();
                }}
                type="button"
              >
                ENVIAR PARA CRÉDITO
              </S.ButtonSkip>
            }
          />
        )}
        {identifierType === 'CNPJ' && (
          <PessoaJuridicaForm
            ref={pessoaJuridicaFormRef}
            customerCnpj={identifier}
            municipios={municipios}
            stopLoadingOnFinish={false}
            finishCallback={finishCallbackPessoaJuridica}
            missingCustomerDataCallback={onMissingCustomerInformation}
          />
        )}
        {popUpDangerActive && (
          <PopUpDanger setPopUpDangerActive={setPopUpDangerActive} />
        )}
      </S.Wrapper>
      {globalContext.warningData.isActive && (
        <PopUpWarning
          title={globalContext.warningData.title}
          label={globalContext.warningData.label}
          isVehicleName={globalContext.warningData.isVehicleName}
          setWarningData={globalContext.setWarningData}
          outOfOrderVehicle={globalContext.warningData.outOfOrderVehicle}
          returnMessageVehicle={globalContext.warningData.returnMessageVehicle}
        />
      )}
      <ShowPopUp handleCheckId={handleCheckId} />
    </>
  );
}
